export function combineArrays(array1, array2) {
  // Ensure both arrays are valid
  if (!Array.isArray(array1) || !Array.isArray(array2)) {
    throw new Error("Both arguments must be arrays.");
  }

  // Determine the length of the longest array
  const maxLength = Math.max(array1.length, array2.length);

  // Create a new array to store the combined objects
  const combinedArray = [];

  // Iterate through the arrays and create objects
  for (let i = 0; i < maxLength; i++) {
    const object = {};

    // Add elements from array1 to the object (if available)
    if (i < array1.length) {
      object.array = array1[i];
    }

    // Add elements from array2 to the object (if available)
    if (i < array2.length) {
      object.title = array2[i];
    }

    combinedArray.push(object);
  }

  return combinedArray;
}

// Example usage
const array1 = [1, 2, 3];
const array2 = ["a", "b", "c", "d"];

const combined = combineArrays(array1, array2);
console.log(combined); // Output: [{ property1: 1, property2: "a" }, { property1: 2, property2: "b" }, { property1: 3, property2: "c" }, { property2: "d" }]
